export default "__VITE_ASSET__322067f3__"